import React, { useState, useEffect } from 'react'
import {
  Box,
  Fab,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Button,
  Card,
  CardContent,
} from '@mui/material'
import { useHistory } from 'react-router-dom'

import AddIcon from '@mui/icons-material/Add'
import CheckIcon from '@mui/icons-material/Check'

import { OrangeButton } from 'components/common/button'
import { useSprCreateMutation } from 'services/hooks/supplierPreferenceRules/useSprCreateMutation'

type TableActionsProps = {
  onDelete: () => void
  bulkActionDisabled: boolean
}

const TableActions = ({ onDelete, bulkActionDisabled }: TableActionsProps) => {
  const [action, setAction] = useState('')
  const [openCreateModal, setOpenCreateModal] = useState(false)
  const [ruleName, setRuleName] = useState('')
  const { mutate: createSprMutate } = useSprCreateMutation()

  const history = useHistory()

  const onChangeBulkAction = (e) => {
    setAction(e.target.value)
    if (e.target.value === 'delete') {
      onDelete()
    }
  }

  useEffect(() => {
    if (bulkActionDisabled) {
      setAction('')
    }
  }, [bulkActionDisabled])

  const onCloseModal = () => {
    setRuleName('')
    setOpenCreateModal(false)
  }

  const onChangeName = (e) => {
    setRuleName(e.target.value)
  }

  const onCreateRule = async () => {
    createSprMutate(
      { name: ruleName },
      {
        onSuccess(data, variables, context) {
          history.push(`/admin/supplier_preference_rules/update/${data.uuid}`)

          onCloseModal()
        },
      }
    )
  }

  return (
    <Card
      sx={{
        position: 'fixed',
        bottom: 30,
        right: 24,
      }}
    >
      <CardContent
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <Box>
          <FormControl
            variant='outlined'
            sx={{
              margin: 1,
              minWidth: 200,
            }}
          >
            <InputLabel id='bulk-actions-select-label'>Bulk Actions</InputLabel>
            <Select
              labelId='bulk-actions-select-label'
              id='bulk-actions-select-outlined'
              value={action}
              onChange={onChangeBulkAction}
              label='Bulk Actions'
              disabled={bulkActionDisabled}
            >
              <MenuItem value=''>
                <em>None</em>
              </MenuItem>
              <MenuItem value='delete'>Delete</MenuItem>
            </Select>
          </FormControl>
        </Box>
        <Box>
          <Fab
            color='primary'
            aria-label='check'
            style={{ marginRight: '1rem' }}
          >
            <CheckIcon />
          </Fab>
          <Fab
            color='primary'
            aria-label='add'
            onClick={() => {
              setOpenCreateModal(true)
            }}
          >
            <AddIcon />
          </Fab>
        </Box>
        <Dialog
          open={openCreateModal}
          onClose={onCloseModal}
          aria-labelledby='form-dialog-title'
        >
          <DialogTitle id='form-dialog-title'>
            Create a new supplier preference rule
          </DialogTitle>
          <DialogContent>
            <TextField
              autoFocus
              margin='dense'
              id='name'
              label='Name'
              fullWidth
              value={ruleName}
              onChange={onChangeName}
            />
          </DialogContent>
          <DialogActions>
            <OrangeButton
              onClick={onCloseModal}
              className='btn-orange'
              color='primary'
              variant='contained'
            >
              Cancel
            </OrangeButton>
            <Button
              color='primary'
              variant='contained'
              disabled={ruleName === ''}
              onClick={onCreateRule}
            >
              Create
            </Button>
          </DialogActions>
        </Dialog>
      </CardContent>
    </Card>
  )
}

export default TableActions
